import { SxProps } from "@mui/material";

export const sxBoxChevron: SxProps = {
    padding: '15px 20px 15px 20px'
}

export const sxLabel: SxProps = {
    color: '#4C4C4C',
    fontWeight: 600,
    marginBottom: '16px'
}

export const sxSubtitle: SxProps = {
    color: '#383838',
    fontWeight: 600,
    fontSize: '14px'
}